var _$20$30$40$50$60$;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (_$20$30$40$50$60$ = {}, _defineProperty(_$20$30$40$50$60$, 10, '#faf0f0'), _defineProperty(_$20$30$40$50$60$, 20, '#fad4d4'), _defineProperty(_$20$30$40$50$60$, 30, '#fab6b6'), _defineProperty(_$20$30$40$50$60$, 40, '#fa8e8e'), _defineProperty(_$20$30$40$50$60$, 50, '#f55353'), _defineProperty(_$20$30$40$50$60$, 60, '#de1b1b'), _defineProperty(_$20$30$40$50$60$, 70, '#b80d0d'), _defineProperty(_$20$30$40$50$60$, 80, '#8f0e0e'), _defineProperty(_$20$30$40$50$60$, 90, '#661414'), _defineProperty(_$20$30$40$50$60$, 100, '#451717'), _$20$30$40$50$60$);